import { useSelector } from "react-redux";
import { pathOr } from "ramda";

import { useLastEcardActions } from "store/LastEcardSlice";
import useRouter from "hooks/useRouter";
import localStorage, { TEMPLATE_GROUP_ID, INVITE_ID } from "utils/localStorage";

const useLastEcard = () => {
  const { setLastEcard } = useLastEcardActions();
  const { location } = useRouter();

  const { ecard } = useSelector((state) => state.LastEcardSlice);

  const isInvite = ecard && ecard.type === "invites";
  const isMake = ecard && ecard.type === "makes";

  const templateGroupId = (() => {
    let id = localStorage.getItem(TEMPLATE_GROUP_ID);
    const tgIdFromUrl = pathOr(null, ["state", "templateGroup"], location);

    if (isInvite && ecard?.templateGroupId) id = ecard.templateGroupId;
    else if (tgIdFromUrl) id = tgIdFromUrl;

    return id;
  })();

  const ecardType = (() => {
    let type;
    const inviteId = localStorage.getItem(INVITE_ID);

    if (ecard && ecard.type) type = ecard.type;
    else if (inviteId) type = "invites";

    return type;
  })();

  return { setLastEcard, ecard, isInvite, isMake, templateGroupId, ecardType };
};

export default useLastEcard;
